import DOMParser from "dom-parser";
import { getNewsApi } from "./backend";

// const dummy_news = `<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="zh-HK" lang="zh-HK"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
// <title>rthk.hk - 即時新聞: 本地 RSS 頻道
// 			</title><style type="text/css">
// 			 				body {letter-spacing:.1em;}
// 						</style><link rel="stylesheet" type="text/css" href="rss_tc.css"></link></head><body><div id="wrapper"><div xmlns="" id="header">
// <h1><a href="https://news.rthk.hk">rthk.hk - 即時新聞: 本地 RSS 頻道
// 			</a></h1>
// <div id="logo"><a href="https://news.rthk.hk"><img src="https://rthk9.rthk.hk/include2010/homepics/images/home_logo.png"></a></div>
// </div>
// <div xmlns="" id="tutorial">
// <h2>什麼是RSS？</h2>
// <p>RSS是一種網上訂閱機制，就像日常訂報紙和雜誌一樣，你可以通過這種網上訂閱機制，訂閱任何喜歡的內容。</p>
// </div>
// <div xmlns="" id="items">
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703776-20230606.htm">孫玉菡明晚往日內瓦　出席國際勞工大會</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 20:05:33 +0800</p>
// <p class="description">勞工及福利局局長孫玉菡明晚前往瑞士日內瓦，以中華人民共和國代表團成員的身份出席第111屆國際勞工大會。

// 在日內瓦期間，孫玉菡將拜訪國際勞工組織亞太區域局局長、中國代表團勞資政三方代表，以及中國常駐聯合國日內瓦辦事處和瑞士其他國際組織代表團。他亦會到訪洛桑一間高等院校。

// 孫玉菡將於本月12日下午返抵本港。他離港期間，勞工及福利局副局長何啟明將署任勞工及福利局局長。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703775-20230606.htm">港隊在全國場地單車錦標賽共奪3金2銀</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 20:02:09 +0800</p>
// <p class="description">全國場地單車錦標賽一連五天在杭州舉行，香港單車代表隊合共取得3金2銀。

// 香港的梁嘉儒和李思穎分別獲得男子及女子全能賽冠軍、伍柏亨在男子4公里個人追逐賽決賽取得亞軍、梁峻榮及梁嘉儒在男子麥迪遜賽取得冠軍、楊礎搖在女子凱林賽取得亞軍。

// 香港隊已分批抵達泰國，準備參加明天至本月13日在泰國羅勇舉行的亞洲公路單車錦標賽。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703773-20230606.htm">警方國安處拘6人　其中2人涉嫌危害國家安全</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 19:18:28 +0800</p>
// <p class="description">警方國家安全處今日在各區拘捕6人，年齡介乎33至64歲，涉嫌「串謀偽造」，其中兩人同時涉嫌「作出具煽動意圖的作為」罪。

// 警方說，6人懷疑串謀在文件上偽造簽署，當中兩人涉嫌危害國家安全，多次透過社交平台持續發布具有煽動意圖的訊息，內容涉及煽動他人引起對中央及香港特區政府的憎恨、支持香港獨立以及鼓吹武力對抗等。
//
// 警方根據法庭手令搜查各人住所，並檢獲有關文件及電子通訊工具。6人正被扣查。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703772-20230606.htm">深水埗倫常命案　一名非華裔女子被控謀殺　明天提堂</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 19:16:10 +0800</p>
// <p class="description">深水埗桂林街一個單位昨日發生倫常命案，3名年齡介乎2至5歲的女童死亡，警方暫控一名29歲非華裔女子3項謀殺罪。案件將於明早在九龍城裁判法院提堂。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703771-20230606.htm">政府擬容許配偶共用醫療券　措施預計下月內推出</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 19:12:55 +0800</p>
// <p class="description">政府提出優化醫療券計劃，計劃容許配偶共用醫療券，以方便長者夫婦善用雙方醫療券配額，使用私營基層醫療服務，並以簡化申領過程為原則，措施預計下月內推出。

// 醫務衞生局向立法會提交文件，根據初步設計，長者和配偶在雙方同意下，只需在任何一方使用醫療券時，一同親身向服務提供者出示身分證和申報婚姻狀況，並登記一次，雙方醫療券戶口隨即在電腦系統連結，直至任何一方提出書面請求退出為止。當局說，戶口連結後，當長者醫療券戶口餘額耗盡，即可使用配偶戶口的醫療券餘額。

// 當局又說，會總結醫療券計劃在港大深圳醫院的經驗，探討進一步將適用範圍擴大到內地大灣區其他醫療服務標準和臨床管治架構相若的醫療機構，特別是採用「香港管理模式」的機構，相關管理模式和醫療水平必須符合條件，並與香港接軌；同時正研究使用醫療券申領付還部分醫保費用的機制。

// 當局提出，將推出為期3年的醫療券獎賞先導計劃，長者只需在健康檢查、慢性疾病診斷管理等特定基層醫療服務，使用至少1000元醫療券，戶口即可獲自動發放500元獎賞。當局正制定細節，將配合「慢性疾病共同治理計劃」，一併在今年第四季推出。

// 政府指出，自今年4月底將醫療券適用範圍擴展至涵蓋四類「認可醫療專業註冊計劃」的醫療專業，截至上月底，已有近70名新增的相關專業人員參與計劃，合資格長者可在近150個服務地點使用醫療券。當局會繼續與認可醫療專業團體合作，呼籲專業人員向衞生署登記參與醫療券計劃。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703769-20230606.htm">首季永久離港提取強積金6700宗　按年跌約11%</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 19:08:00 +0800</p>
// <p class="description">積金局公布，截至今年3月底止，首季以永久離開香港為由，提取強積金權益的申索有6700宗，按年和按季分別跌約11%和4%；有關金額涉及15.7億元，按年和按季分別跌近22%和8%。

// 首季強積金總資產值增至近1.11萬億元。至3月底止，去年度強積金年率化淨回報負5.9%，連續2年錄得負值。自強積金制度於2000年實施以來，強積金年率化淨回報為2.7%。

// 多種強積金基金於去年度的年率化淨回報均錄得負值，以股票基金表現最差，回報為負7.9%，混合資產基金和債券基金的回報分別負7%和負5.9%。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703763-20230606.htm">黃元山︰特首政策組專家組首次會議圍繞高質量發展</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:37:04 +0800</p>
// <p class="description">特首政策組專家組本月16日在政府總部舉行首次會議，討論香港如何實現高質量發展，3個專家組亦會分別就社會發展、經濟發展及研究策略交流分享。

// 特首政策組組長黃元山強調，政策組的工作是因應特首施政方針及政策優先次序，作出內部調研，與政策局有明顯分工。

// 至於會否與政策局的研究重疊，兩者如何協調，黃元山說，政策組負責內部研究，因應特首期望有關研究具前瞻性及策略性，能夠融入國家發展大局，並與國際形勢相關；而政策局會就政策「落地」推進，做政策研究及民調與諮詢等工作，形容分工清晰。

// 被問到近日發生兩宗命案，有指政府對於精神健康等方面支援不足，政策組會否研究有關社會問題，將向政府提供甚麼建議。黃元山重申，會根據特首指派方向，安排內部調研工作，提供額外研究資料及成果，而政策局會推進並落實調研，兩者各司其職。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703765-20230606.htm">60多名肝病患者正輪候換肝　今年至今只有14宗捐肝</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:34:33 +0800</p>
// <p class="description">醫管局表示，有60多名肝病患者正在輪候換肝，但近年捐贈肝臟有下降趨勢，今年至今只有14宗，數字非常少，過去一個月未曾處理遺體捐贈肝臟的個案。

// 醫管局又說，未來希望參考外國經驗，接受使用心臟衰竭人士的肝臟進行移植。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703748-20230606.htm">總商會調查：79%人離職為更好薪酬　移民佔70%</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:22:53 +0800</p>
// <p class="description">香港總商會早前進行調查，有74%受訪公司表示正面對人才短缺問題，其中61%公司指情況已持續一至三年。離職原因方面，佔79%是尋求更好薪酬，移民佔70%，尋求工作與生活平衡則有51%。

// 總商會認為，在人手短缺的情況下，員工面對工作壓力，會因更重視工作與生活平衡而離職。在人手更緊絀下，或會促使企業可能將部分或所有業務遷離香港。

// 總商會總裁梁兆基指出，有受訪企業認為公司人才短缺最嚴重的是中層員工，其次是初級員工，建議政府擴大及簡化現有輸入人才計劃的標準。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703753-20230606.htm">李家超對深水埗命案感難過　呼籲保護兒童</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:14:38 +0800</p>
// <p class="description">一名居於深水埗劏房單位的印度籍女子，涉嫌用枕頭焗死三名年幼女兒。行政長官李家超表示，和很多市民一樣，對這宗家庭暴力的悲劇感到傷心和難過。

// 李家超表示，政府關注家庭暴力，執法部門及社會福利署都會跟進，希望做到「早介入，早支援」；他亦呼籲市民守望相助，同心協力保護兒童。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703750-20230606.htm">特首︰蓄意破壞器官捐贈計劃無恥　會追究法律責任</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:14:30 +0800</p>
// <p class="description">警方昨天拘捕4名男子，涉嫌與取消器官捐贈登記有關。行政長官李家超表示，蓄意破壞器官捐贈計劃，是卑劣和無恥行為，政府必須譴責有關無恥行為，亦會追究法律責任。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703749-20230606.htm">行會同意中低層公僕加薪4.65%　高層加2.87％</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:10:33 +0800</p>
// <p class="description">行政會議同意政府提出今年度公務員薪酬調整方案，中、低層公務員劃一加薪4.65%，高層公務員加2.87%。

// 高級公務員協會，對政府建議高層公務員加薪2.87%，表示極度失望，認為政府未有充分考慮高級公務員士氣，及職方對薪酬調整的要求。華員會亦對建議加薪幅度感到失望。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703751-20230606.htm">律政司入稟禁止四項與《願榮光歸香港》非法行為</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 18:07:57 +0800</p>
// <p class="description">律政司向法庭申請禁制令及臨時禁制令，禁止四項與歌曲《願榮光歸香港》有關的非法行為，正等候法庭指示。

// 禁制令要求以任何方式，包括在互聯網廣播、表演、發布或展示等有關歌曲，歌曲的曲詞、以至歌曲的改編本而實質上與歌曲相似者亦包括在內。

// 政府發言人指，為維護國家安全，有關申請是必要、合理和合法。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703756-20230606.htm">鄉議局倡上水丙崗村建1.2萬單位　稱快過發展高球場</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 17:26:21 +0800</p>
// <p class="description">鄉議局提出上水丙崗村建屋計劃，主要在荒廢農地興建9幢樓宇，樓高由31層至46層不等，預計可提供約12000個單位，每個單位平均457呎。

// 鄉議局形容，有關農地地勢平坦，會有學校、餐飲處所及巴士總站等配套，沒有古樹，涉及少量寮屋戶，但需要建設新路接駁選址與交通交匯處。鄉議局說，如果政府採納這計劃，並建設新路，有助釋放附近相關發展面積，相信發展速度可比發展粉嶺高球場32公頃用地快。

// 至於這個建屋計劃，是否粉嶺高球場有關用地發展的替代方案，鄉議局主席劉業強說，並非指這是替代方案，各行各業都要土地，相信政府需要土地儲備，強調並無就丙崗村建屋計劃與政府商討。

// 被問到如果政府收地發展，將涉及多少金額， 劉業強相信，政府會按現行收地機制補償。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703755-20230606.htm">國泰航空本月底向政府派付遞延股息　將適時贖回優先股</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 17:21:30 +0800</p>
// <p class="description">國泰航空首次向政府派付優先股股息，集團宣布，將於本月底就政府持有的優先股，派付約15.24億元的遞延股息，亦即派付所有累計遞延股息。集團亦有意派付所有將到期的優先股股息，並在適當時候贖回優先股。

// 國泰表示，無需動用政府提供的78億元過渡貸款融資，這項融資將於本周四到期。

// 行政總裁林紹波表示，隨著旅遊限制撤銷及出行需求恢復，今年至今繼續錄得經營正現金流，財務狀況持續穩健。

// 他說，集團深信為香港重建國泰的復常之路已步上正軌，現時是適當時候開始回報政府對集團的支持，並感謝政府及所有股東，在新冠疫情期間的大力支持，讓集團渡過成立76年來最嚴峻時期。

// 集團重申，目標今年底運作疫情前約70%的客運運力，明年底恢復至疫情前水平。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703754-20230606.htm">運輸署提醒使用易通行車主須14個工作內繳交隧道費</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 17:14:34 +0800</p>
// <p class="description">青沙管制區、城門隧道和獅子山隧道已實施「易通行」，運輸署表示，截至昨日，發出超過76萬張車輛貼，佔全港已領牌的車輛超過94%，當中約82%的車輛已開立「易通行」戶口。「易通行」在青沙管制區、城門隧道及獅子山隧道平均每日收取約20萬架次的隧道費。

// 運輸署提醒，曾使用青沙管制區、城門隧道和獅子山隧道而未繳交隧道費的車主，必須在使用隧道後的14個工作天內繳交隧道費。逾期繳交會被徵收每程175元首筆附加費。如車主未能在附加費通知送達日後的21日前，全數繳付未繳交的隧道費及首筆附加費，須再繳交350元額外附加費。逃避繳交隧道費可被罰款5000元，運輸署亦不會為有關車輛續牌。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703747-20230606.htm">漁護署於油尖旺店舖檢50件懷疑象牙製品</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 16:56:20 +0800</p>
// <p class="description">漁護署昨日在油尖旺區一間店舖檢獲50件懷疑象牙製品。

// 漁護署日前接獲投訴，指油尖旺區有店舖涉嫌非法出售受管制象牙，漁護署人員在店舖發現共50件懷疑象牙製品，將檢取作進一步調查。

// 發言人說，政府一直致力保護瀕危物種，包括象，2021年12月31日起禁止進口、再出口及為商業目的而管有象牙，「古董象牙」除外。漁護署已加強巡查，並繼續與海關和相關政府部門保持緊密聯繫，以打擊象牙走私及非法貿易活動。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703745-20230606.htm">海關破獲兩宗私煙案　估計市值逾5200萬元</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 16:53:57 +0800</p>
// <p class="description">海關在葵涌海關大樓驗貨場破獲兩宗懷疑走私案件，檢獲共約11.6噸懷疑未完稅製成煙草，估計市值超過5200萬元，應課稅值約3500萬元。

// 海關於本月2日透過風險評估，揀選及檢查一個報稱載有地毯的40呎貨櫃，該貨櫃從廣東抵港並準備轉口往澳洲。關員在貨櫃內發現載有一批以透明膠袋包裝的懷疑未完稅製成煙草，共重約9900公斤，估計市值約4480萬元。

// 另外，海關昨日同樣從一個由廣東抵港，並準備轉口往澳洲的40呎貨櫃內，發現一批以茶葉包裝袋包裝的懷疑未完稅製成煙草，共重約1700公斤，估計市值約750萬元。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703743-20230606.htm">醫管局：受疫情影響近年捐贈肝臟數字明顯下跌</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 16:50:57 +0800</p>
// <p class="description">醫管局表示，近年捐贈肝臟數字有下降趨勢，由2021年的53宗遺體和活體捐贈，下跌至去年的29宗，今年截至3月底，更只有11宗，同期有64人正輪候接受肝臟移植。

// 瑪麗醫院肝膽胰外科及肝臟移植榮譽顧問醫生黃楚琳表示，本港2018年之前，每年平均有約40宗遺體肝臟捐贈個案，但受疫情影響，近年數字明顯下跌，自己近一個月未能處理一宗遺體捐贈，今年截至昨日，只有大約14宗肝臟捐贈，其中遺體捐贈只有9宗，形容數目非常少，而輪候人數持續增加。

// 黃楚琳提到，活體捐贈者的選擇嚴謹，近年患有脂肪肝人數有上升趨勢，不適合捐贈，減少活體捐贈肝臟個案的數目。

// 她又說，末期肝病患者如果1至3個月內未能接受移植將會離世，截至去年底，瑪麗醫院肝臟移植組完成了1585宗肝臟移植手術，當中近九成為成人個案。</p>
// </div>
// <div class="item">
// <h3><a href="https://news.rthk.hk/rthk/ch/component/k2/1703741-20230606.htm">梁兆基：移民對本港人才流失影響未放緩　嚴重影響經濟</a></h3>
// <p class="pubdate">Tue, 06 Jun 2023 16:46:17 +0800</p>
// <p class="description">香港總商會公布今年人才短缺問卷調查結果，發現有74%的受訪公司面對人才短缺問題，當中超過八成企業受人才短缺情況持續困擾1年以上。

// 總商會在4月對各行業進行問卷調查，回收共196份問卷，其中54%受訪企業聘用超過200名員工，有28%公司的員工人數為50人或以下。調查中有受訪公司指出，有七成員工離職的原因是移民海外，另有五成離職員工離職的原因是「尋求工作與生活平衡」。另外，有59%的受訪公司表示，公司人手最短缺的工種年均底薪水平為20萬至50萬，反映初級及中級管理層短缺。

// 香港總商會總裁梁兆基表示，移民對本港人才流失的影響未有放緩跡象，勞動人口在2019年初至2022年底減少約21萬。他又說，疫後有更多員工注重「尋求工作與生活平衡」，間接令到總勞動的時日減少，變相需要補充更多勞動人口，才可保持同樣的產出。

// 梁兆基建議政府的輸入勞工政策應該著眼於中低層員工，並將專才輸入的需求分開處理。他表示，勞動力不足問題已經嚴重影響本港未來經濟發展，建議政府擴大及簡化現有人才計劃的標準。</p>
// </div>
// </div>
// <div xmlns="" id="footer"><p>© 香港電台</p></div></div></body></html>`;

let instance;
let updateFrequencyMinutes = 15;
let globalState = {
  ts: Date.now(),
  accumulated_news: [],
  currentIndex: 0,
};

class NewsData {
  constructor() {
    if (instance) {
      throw new Error("New instance cannot be created!!");
    }
    globalState.ts = Date.now();
    instance = this;
  }

  getPropertyByName(propertyName) {
    return globalState[propertyName];
  }

  setPropertyValue(propertyName, propertyValue) {
    globalState[propertyName] = propertyValue;
  }

  get newsItems() {
    const ts = Date.now();
    return (async () => {
      if (
        ts - globalState.ts > 1000 * 60 * updateFrequencyMinutes ||
        globalState.accumulated_news.length === 0
      ) {
        console.log(
          `${ts - globalState.ts / 1000 / 60} minutes, fetching news . . .`
        );
        globalState.ts = ts;
        await this._getNews();
      }
      return {
        pendingNews: globalState.accumulated_news,
      };
    })();
  }

  parseNews(xml) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(xml, "text/xml");
    // const html_items = htmlDoc.getElementsByClassName("item");
    const html_items = htmlDoc.getElementsByTagName("item");
    var items = [];
    html_items.forEach((item_el, i) => {
      // const title = Array.from(
      //   Array.from(item_el.getElementsByTagName("h3"))
      //     ?.shift()
      //     ?.getElementsByTagName("a")
      // ).shift()?.innerHTML;
      // const description = Array.from(
      //   item_el.getElementsByClassName("description")
      // )?.shift().innerHTML;
      const title_new = item_el
        .getElementsByTagName("title")
        ?.shift()
        .innerHTML?.replace("<![CDATA[", "")
        .replace("]]>", "");
      const description_new = item_el
        .getElementsByTagName("description")
        ?.shift()
        .innerHTML?.replace("<![CDATA[", "")
        .replace("]]>", "");
      const isNew =
        globalState.accumulated_news.filter(({ title, description }) => {
          return title === title_new;
        }).length === 0;
      if (isNew) {
        items.push({ title: title_new, description: description_new });
      }
    });
    // console.log(items);
    return items;
  }

  async _getNews() {
    const response = await getNewsApi();
    const _news = this.parseNews(response);
    globalState.accumulated_news = [...globalState.accumulated_news, ..._news];
    // globalState.news = response;
    // console.log(response);
  }

  // get weather() {
  //   const ts = Date.now();
  //   return (async () => {
  //     if (
  //       ts - globalState.ts > 1000 * 60 * updateFrequencyMinutes ||
  //       Object.keys(globalState.localWeather).length === 0 ||
  //       Object.keys(globalState.weatherReport).length === 0
  //     ) {
  //       console.log(
  //         `${ts - globalState.ts / 1000 / 60} minutes, fetching weather . . .`
  //       );
  //       globalState.ts = ts;
  //       await this.updateWeather();
  //     }
  //     return {
  //       localWeather: globalState.localWeather,
  //       weatherReport: globalState.weatherReport,
  //     };
  //   })();
  // }

  // async _getWeather() {
  //   const response = await getLocalWeatherApi();
  //   globalState.localWeather = response;
  //   console.log(response);
  // }

  // async updateWeather() {
  //   await this._getWeather();
  //   await this._getWeatherReport();
  // }
}

let NewsInstance = Object.freeze(new NewsData());

export { NewsInstance };
